import React, { useState, useEffect, useContext } from "react";
import axios from "../../../Axios";
import { Urls } from "../../../Urls";
import "./NewEnquiry.css";
import { toast } from "react-toastify";
import Loader from "../../Loader";
import {
  currentRequestTimeStamp,
  isMobile,
  Activity,
  spotFilterOptions,
  expiryDateFormatter,
} from "../../../Constants";
import classes from "../TrucksAvailable.module.css";
import Modal from "../../Shared/PopupModal/PopupModal";
import { CommonModal } from "../../Freightrates1/Utility";
import { useHistory, useParams, useLocation } from "react-router-dom";
import UpgradeModal from "../../UpgradeModal/UpgradeModal";
import InputFields from "./inputfields/InputFields";
import mixpanel from "mixpanel-browser";
import { checkModuleAccess, titleCase, getContractTenureOptions } from "../../../Utility";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import { auth } from "../../firebase/firebase";
import ReactGA from "react-ga4";

import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
import AddedLanes from "./AddedLanes";
import MobileAddedLanes from "./MobileAddedLanes";
import MultiSelectWithCheckbox from "../../Shared/MultiSelectCheckbox/MultiSelectCheckbox";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import useViewOnlyAccess from "../../../hooks/useViewOnlyAccess";
import { MastersChangeLog } from "../../CompanyProfileNew/Utility";
import MultiSelectFilterUI from "../../Shared/newfilterui/MultiSelectFilterUI";

import { useNewEnquiryHandlers } from "./useNewEnquiryHandlers";
import { useNewEnquiryFilters } from "./useNewEnquiryFilters";
import EnquiryToolbar from "./EnquiryToolbar";
import ActiveFiltersPills from "./ActiveFiltersPills";
import EnquirySubmitFooter from "./EnquirySubmitFooter";

const DEFAULT_SORT_OPTIONS = [{ value: "created_date", label: "Created Date" }];

const NewEnquiry = ({
  backbutton = false,
  discovernowbutton = false,
  from = false,
  rspl = [],
  onbackclick,
  planningbutton = false,
  current_truck = {},
  update_orders = "",
  all_spot_list = [],
}) => {
  const [materialCategories, setMaterialCategories] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [origin, setorigin] = useState({});
  const [adhoc_policy, setAdhoc_policy] = useState([]);
  const [inputorigin, setinputorigin] = useState("");
  const [destination, setdestination] = useState({});
  const [inputdestination, setinputdestination] = useState("");
  const [selectedTrucks, setselectedTrucks] = useState([]);
  const [TruckTypes, setTruckTypes] = useState([]);
  const [truckrequired, settruckrequired] = useState(0);
  const [tonnage, settonnage] = useState("");
  const [capacity, setcapacity] = useState("");
  const [date, setduedate] = useState("");
  const [send_data, setsend_data] = useState([]);
  const [show, setshow] = useState(false);
  const [filtered_details, setfiltered_details] = useState([]);
  const [resdata, Setresdata] = useState([]);
  const [qualitativeInputs, setQualitativeInputs] = useState({
    contracted_terms: { value: false },
    save_company_profile: { value: false },
    policy_terms: { value: "" },
    insurance: { value: "" },
    insured_amount: { value: "" },
    fuel_clause: { value: "" },
    detention_charges: { value: "" },
    damages_clause: { value: "" },
    shortage_clause: { value: "" },
    uploaded_files: "",
  });
  const [transporterlistempty, settransporterlistempty] = useState(false);
  const [tenure, settenure] = useState([
    { label: "Spot Rates", value: "Spot Rates" },
  ]);
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [validateUser, setvalidateUser] = useState("basic");
  const [isdownload, setisdownload] = useState(false);
  const [iscompanycheck, setiscompanycheck] = useState(false);
  const [isquotationcheck, setisquotationcheck] = useState(false);
  const [ischat, setischat] = useState(false);
  const [profile_view_allowed, setprofile_view_allowed] = useState("no");
  const [profile_view_count, setprofile_view_count] = useState(0);
  const [auctionAllowed, setAuctionAllowed] = useState("no");
  const [allowed_auction, setallowed_auction] = useState(0);
  const [isAuction, setisAuction] = useState(false);
  const [isSpotNegotiation, setisSpotNegotiation] = useState(false);
  const [isPlacement, setisPlacemant] = useState(false);
  const [isIndent, setisIndent] = useState(false);
  const [userid, setuserid] = useState("");
  const [expiredEnquiries, setexpiredEnquiries] = useState(false);
  const [notnc, setNotnc] = useState(true);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [company_id, setCompany_id] = useState("");
  const [filter, setFilter] = useState(false);
  const [currentFilterPayload, setCurrentFilterPayload] = useState(null);
  const [initialPayload, setInitialPayload] = useState(null);
  const [isFilterActive, setIsFilterActive] = useState(false);

  const [cancelEnquiry, setcancelEnquiry] = useState(false);
  const [approveEnquiry, setapproveEnquiry] = useState(false);
  const [skipactive, setSkipactive] = useState(0);
  const [totalcount, settotalcount] = useState(0);
  const [requestapprovallist, setRequestapprovallist] = useState([]);
  const [useroption, setUseroption] = useState([]);
  const [newSpot, setNewSpot] = useState(false);
  const {
    loading,
    canAccess,
    canCreate,
    checkActionPermission,
    isRestricted,
    handleRestrictedClick,
    canAccessReports,
  } = useViewOnlyAccess("spot");
  const { noAccess: tncNoAccess } = useViewOnlyAccess(
    "terms_conditions",
    "lorri_terms_conditions",
    true,
  );
  const { noAccess, noModuleAccess } = useViewOnlyAccess(
    "spot",
    "lorri_spot",
    true,
  );
  const spotNoAccess = noAccess || noModuleAccess;


  const [interval_days, setinterval_days] = useState(() => {
    const daysVal = searchParams.get("days");
    const d = parseInt(daysVal, 10);
    return [1, 7, 15, 30, 90, 180].includes(d) ? d : 7;
  });
  const [mastertransporterlist, setmastertransporterlist] = useState([]);
  const [userview, setuserview] = useState(() => {
    const v = searchParams.get("view");
    return v === "company" ? false : true;
  });
  const [isApprover, setIsApprover] = useState(false);
  const [approver_list, setApprover_list] = useState([]);
  const [approvalType, setApprovalType] = useState("bulk");
  const [showapprovingloader, setshowapprovingloader] = useState(false);
  const [company_name, setCompany_name] = useState("");
  const [visible_enquiry, setvisible_enquiry] = useState(50);
  const [autoPushIndent, setAutoPushIndent] = useState("");
  const [companyProfileData, setCompanyProfileData] = useState("");
  const [skipLimit, setskipLimit] = useState(0);
  const { userDetails } = useContext(UserApiContext);
  const { companyProfile, users } = useContext(UserApiContext);
  var company_mail = userDetails?.email;
  var tenurelist = getContractTenureOptions(adhoc_policy);

  useEffect(() => {
    var defaultTenure = tenurelist?.find((opt) => !opt.isDisabled);
    if (defaultTenure) {
      settenure([defaultTenure]);
    }
  }, [adhoc_policy]);
  // const [enquiryBucket, setEnquiryBucket] = useState(() => {
  //   const b = searchParams.get("bucket");
  //   return ["active", "approved", "expired", "cancelled", "all"].includes(b) ? b : "active";
  // });
  const SPOT_BUCKETS = [
    "active",
    "approved",
    "expired",
    "archived",
    "cancelled",
    "all",
    "pending_approval",
    "pending_acceptance",
  ];

  const [enquiryBucket, setEnquiryBucket] = useState(() => {
    const b = searchParams.get("bucket");
    return SPOT_BUCKETS.includes(b) ? b : "active";
  });
  const [enquiryLevel, setEnquiryLevel] = useState(() => {
    const v = searchParams.get("view");
    return v === "company" ? "company_view" : "user_view";
  });
  const [enquiryTransition, setEnquiryTransition] = useState(false);

  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [orgList, setOrgList] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [tncData, setTncData] = useState([]);
  var user_name = userDetails?.user_name;
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData,
  );

  const handlersRef = React.useRef({
    mapEnquiryData: (list) => list,
    reload_data: () => { }
  });

  const {
    selected_origin_name, setselected_origin_name,
    selected_destination_name, setselected_destination_name,
    selected_truck_type, setselected_truck_type,
    selected_user, setselected_user,
    selected_placement_date, setselected_placement_date,
    selected_contract, setselected_contract,
    filters_applied, setFilters_applied,
    list_user, setlist_user,
    list_origins, setlist_origins,
    list_destinations, setlist_destinations,
    list_trucks, setlist_trucks,
    list_placement, setlist_placement,
    list_contract, setlist_contract,
    list_adhoc_ids, setlist_adhoc_ids,
    selected_adhoc_id, setselected_adhoc_id,
    apply_Filter,
    filtersClicked
  } = useNewEnquiryFilters({
    company_mail, interval_days, setinterval_days, userview, setuserview,
    cancelEnquiry, setcancelEnquiry, expiredEnquiries, setexpiredEnquiries,
    approveEnquiry, setapproveEnquiry, planningbutton, setshow, setskipLimit,
    setSkipactive, skipactive, settotalcount, setfiltered_details,
    filter, setIsApprover, history, TrackMixPanel, visible_enquiry,
    mapEnquiryData: (list) => handlersRef.current.mapEnquiryData(list),
    reload_data: (data) => handlersRef.current.reload_data(data)
  });

  const handlers = useNewEnquiryHandlers({
    setEnquiryBucket, setvisible_enquiry, setIsFilterActive, setCurrentFilterPayload,
    initialPayload, enquiryLevel, enquiryBucket, visible_enquiry, company_mail,
    setcancelEnquiry, setexpiredEnquiries, setapproveEnquiry, setIsApprover, settotalcount,
    setfiltered_details, setshow, planningbutton, rspl, tenure, settransporterlistempty,
    setsend_data, send_data, Setresdata, setTruckTypes, origin, destination, selectedTrucks,
    truckrequired, tonnage, capacity, date, selectedIndustry, mastertransporterlist,
    TrackMixPanel, setorigin, setdestination, setinputorigin, setinputdestination,
    setselectedTrucks, setNewSpot, setSelectedIndustry, settruckrequired, settonnage,
    setcapacity, setduedate, settenure, tenurelist, onbackclick, requestapprovallist,
    setRequestapprovallist, company_id, discovernowbutton, userDetails, qualitativeInputs,
    companyProfile, userid, update_orders, history, filters_applied, setSkipactive,
    skipactive, apply_Filter, skipLimit, currentFilterPayload, setSelectedOrg, tncData,
    setQualitativeInputs, setUseroption, all_spot_list, current_truck, adhoc_policy,
    interval_days, setinterval_days, setEnquiryLevel, isSuperAdmin, isSpotNegotiation
  });

  handlersRef.current = handlers;

  const {
    handleFilterApply, handleFilterReset, mapEnquiryData, fetchSpotData, dropDownSelect,
    getDatafromdiscovernow, getDatafromPlanning, getBenchmarkData, reload_data, getTruckTypes,
    addLanetoProcurement, onInputChangeHandler, closeButtonModal1, closeModal1, addrequest,
    getchecked, getnegotiatedisaable, deleteHandler, onChangeTruckTypes, submitHandler,
    oncloseHandler, closeIndentModal, closeSummaryModal, getEnquiries, getOnChange,
    cancelApprovalPending, getStatus, handleOutsideFilterChange
  } = handlers;

  useEffect(() => {
    (async () => {
      if (userDetails && userDetails?.policy && userDetails?.policy?.type) {
        setAdhoc_policy(userDetails?.policy?.adhoc);
        setvalidateUser(userDetails?.policy?.type);
        setuserid(userDetails?.user_id);
        setprofile_view_allowed(userDetails?.policy?.lsp_profiles?.allowed);
        setprofile_view_count(
          userDetails?.policy?.lsp_profiles?.allowed_profiles,
        );
        setAuctionAllowed(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.auction &&
            userDetails.policy?.auction &&
            userDetails?.policy?.auction?.allowed
            ? userDetails.policy.auction.allowed
            : "no",
        );
        setallowed_auction(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.auction &&
            userDetails.policy?.auction?.allowed_auctions
            ? userDetails.policy.auction?.allowed_auctions
            : 0,
        );
        setisdownload(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.adhoc &&
            userDetails.policy?.adhoc?.allowed_download === "yes"
            ? true
            : false,
        );
        setiscompanycheck(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.adhoc &&
            userDetails.policy.adhoc?.allowed_view_company_enquiries === "yes"
            ? true
            : false,
        );
        setisquotationcheck(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.adhoc &&
            userDetails.policy.adhoc?.allowed_view_quotation === "yes"
            ? true
            : false,
        );
        setischat(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.adhoc &&
            userDetails.policy.adhoc?.allowed_view_chat === "yes"
            ? true
            : false,
        );
        setisAuction(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.adhoc &&
            userDetails.policy.adhoc?.spot_auction === "yes"
            ? true
            : false,
        );
        setisSpotNegotiation(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.adhoc &&
            userDetails.policy.adhoc?.allowed_negotiation === "yes"
            ? true
            : false,
        );
        setisPlacemant(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.adhoc &&
            userDetails.policy.adhoc?.placement_details === "yes"
            ? true
            : false,
        );
        setisIndent(
          userDetails &&
            userDetails.policy &&
            userDetails.policy?.adhoc &&
            userDetails.policy.adhoc?.move_to_indent === "yes"
            ? true
            : false,
        );
        setmastertransporterlist(
          userDetails &&
            userDetails.policy &&
            userDetails?.spot_transporter_list &&
            userDetails.spot_transporter_list.length > 0
            ? userDetails.spot_transporter_list
            : [],
        );
      }
    })();
  }, [userDetails]);

  useEffect(() => {
    getTruckTypes();
  }, []);

  useEffect(() => {
    if (
      !isMobile() &&
      requestapprovallist &&
      requestapprovallist.length > 0 &&
      requestapprovallist.length !== filtered_details.length
    ) {
      const targetRow = document.getElementById(
        `enquiry${requestapprovallist[requestapprovallist.length - 1].truck_enquiry_id
        }`,
      );
      if (targetRow) {
        targetRow.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [requestapprovallist]);

  const getEnquiryApis = () => {
    if (backbutton || discovernowbutton || planningbutton) {
      if (companyProfile && companyProfile.domain_data) {
        setCompany_id(companyProfile.domain_data.company_id);
      }
      return;
    }
    setshowapprovingloader(true);
    if (companyProfile && companyProfile.domain_data) {
      setCompany_id(companyProfile.domain_data.company_id);
      axios
        .get(
          `${Urls.companyProfile}?company_id=${companyProfile.domain_data.company_id}&projections_disable=network_collection_data,network,financials`,
        )
        .then((res) => {
          const profileData = res.data[0];
          setCompanyProfileData(profileData);
          setshowapprovingloader(false);
          setCompany_name(profileData.company_name);
          if (profileData.enquiry?.enquiry_approvers?.length > 0) {
            setAutoPushIndent(profileData.enquiry.auto_push_indent);
            if (
              profileData.enquiry?.enquiry_transition &&
              profileData.enquiry?.enquiry_transition === "yes"
            ) {
              setEnquiryTransition(true);
            }
            setApprover_list(profileData.enquiry.enquiry_approvers);
            const approverExists = profileData.enquiry.enquiry_approvers.some(
              (u) => u.email === userDetails?.email
            );
            setIsApprover(approverExists);

            if (!planningbutton) {
              axios
                .get(
                  `${Urls.spot}?field=get_material_types&company_id=${companyProfile.domain_data.company_id}`,
                )
                .then((res) => {
                  if (res?.data?.length > 0) {
                    setMaterialCategories(res?.data);
                    setSelectedIndustry([]);
                  }
                })
                .catch(console.log);
            }
          } else {
            toast.info(
              "Please add an approver in company profile to approve the enquiries.",
            );
          }
          let visibleEnquiry = parseInt(profileData.enquiry?.visible_enquiry, 10) || 50;
          if (visibleEnquiry <= 0) visibleEnquiry = 50;
          setvisible_enquiry(visibleEnquiry);
          const getLocalYMD = (d) => `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${("0" + d.getDate()).slice(-2)}`;
          const tDate = new Date();
          const toDateString = getLocalYMD(tDate);

          const params = new URLSearchParams(window.location.search);
          const urlDays = params.get("days") || "7";
          const d = parseInt(urlDays, 10);

          let dateFilter;
          if (d === 1) {
            dateFilter = {
              label: "Created Date",
              op: "is",
              key: "created_date",
              type: "date",
              values: [getLocalYMD(new Date())]
            };
          } else {
            if ([7, 15, 30, 90].includes(d)) {
              tDate.setDate(tDate.getDate() - d);
            } else {
              tDate.setDate(tDate.getDate() - 7);
            }
            const fromDateString = getLocalYMD(tDate);
            dateFilter = {
              label: "Created Date",
              op: "between",
              key: "created_date",
              type: "date",
              values: [fromDateString, toDateString]
            };
          }

          const urlBucket = params.get("bucket") || "active";
          const urlView = params.get("view") === "company" ? "company_view" : "user_view";
          const urlPage = parseInt(params.get("page") || "1", 10);

          const initialPayloadObj = {
            company_id: companyProfile?.domain_data?.company_id || company_id,
            email: userDetails?.email,
            bucket: urlBucket,
            filters: [dateFilter],
            filtersOperator: "and",
            date_range: [],
            view: urlView,
            pagination: { skip: (urlPage - 1) * visibleEnquiry, limit: visibleEnquiry },
            sort: { key: "created_date", order: "desc" },
          };

          const componentInitialPayload = { ...initialPayloadObj };
          delete componentInitialPayload.bucket;

          setInitialPayload(componentInitialPayload);
          setCurrentFilterPayload(componentInitialPayload);
          fetchSpotData(initialPayloadObj);

          if (profileData.enquiry?.approval_type) {
            setApprovalType(profileData.enquiry.approval_type);
          }
          if (profileData.contact_information?.length > 0) {
            profileData.contact_information.map((user) => {
              if (
                user.email === userDetails?.email &&
                user.super_admin
              ) {
                setIsSuperAdmin(true);
              }
            });
          }
          let tnc = {};
          if (companySettingData && companySettingData?.masters_setting) {
            if (
              companySettingData?.masters_setting?.masters_show_level ===
              "organization_level"
            ) {
              if (users && users?.user_details) {
                const organization_list =
                  companySettingData?.contact_information?.find(
                    (t) => t?.email === users?.user_details?.email,
                  )?.organization;
                if (
                  organization_list?.length === 0 ||
                  organization_list === undefined
                ) {
                  setSelectedOrg("company");
                  tnc = profileData?.terms_and_conditions?.find(
                    (t) => t?.organization_id === "company",
                  );
                } else {
                  setOrgList(organization_list);
                  setSelectedOrg(organization_list[0]?.id);
                  tnc = profileData?.terms_and_conditions?.find(
                    (t) => t?.organization_id === organization_list[0]?.id,
                  );
                }
              }
            } else {
              setSelectedOrg("company");
              setOrgList([]);
              tnc = profileData?.terms_and_conditions?.find(
                (t) => t?.organization_id === "company",
              );
            }
          } else {
            setSelectedOrg("company");
            setOrgList([]);
            tnc = profileData?.terms_and_conditions?.find(
              (t) => t?.organization_id === "company",
            );
          }
          setTncData(profileData?.terms_and_conditions);
          if (tnc && tnc?.primary && tnc?.primary?.payment_terms) {
            setNotnc(false);
          }
          const newData = {
            contracted_terms: tnc?.primary?.contracted_terms
              ? { value: tnc?.primary?.contracted_terms }
              : false,
            save_company_profile: tnc?.primary?.save_company_profile
              ? { value: tnc?.primary?.save_company_profile }
              : { value: false },
            policy_terms: tnc?.primary?.payment_terms
              ? { value: tnc?.primary?.payment_terms }
              : "",
            insurance: tnc?.primary?.insurance
              ? { value: tnc?.primary?.insurance }
              : "",
            insured_amount: tnc?.primary?.insured_amount
              ? { value: tnc?.primary?.insured_amount }
              : "",
            fuel_clause: tnc?.primary?.fuel
              ? { value: tnc?.primary?.fuel }
              : "",
            detention_charges: tnc?.primary?.detention
              ? { value: tnc?.primary?.detention }
              : "",
            damages_clause: tnc?.primary?.damage
              ? { value: tnc?.primary?.damage }
              : "",
            shortage_clause: tnc?.primary?.shortages
              ? { value: tnc?.primary?.shortages }
              : "",
            service_level_adherence_clause: tnc?.primary
              ?.service_level_adherence_clause
              ? { value: tnc?.primary?.service_level_adherence_clause }
              : "",
            uploaded_files: tnc?.primary?.uploaded_files || "",
          };
          setQualitativeInputs(newData);
        })
        .catch(console.log);
    }
  };

  useEffect(() => {
    getEnquiryApis();
  }, [companyProfile]);

  useEffect(() => {
    if (backbutton || discovernowbutton || planningbutton) return;

    const params = new URLSearchParams(location.search);
    let updated = false;

    const pageVal = parseInt(params.get("page"), 10);
    if (isNaN(pageVal) || pageVal < 1) {
      params.set("page", "1");
      updated = true;
    }

    const daysVal = parseInt(params.get("days"), 10);
    if (![1, 7, 15, 30, 90].includes(daysVal)) {
      params.set("days", "7");
      updated = true;
    }

    const bucketVal = params.get("bucket");
    // if (!["active", "approved", "expired", "archived", "cancelled", "all"].includes(bucketVal)) {
    //   params.set("bucket", "active");
    //   updated = true;
    // }
    if (!SPOT_BUCKETS.includes(bucketVal)) {
      params.set("bucket", "active");
      updated = true;
    }

    let viewVal = params.get("view");
    if (viewVal === "my_enquiries" || viewVal === "user_view") viewVal = "user";
    if (viewVal === "company_enquiries" || viewVal === "company_view")
      viewVal = "company";
    if (!["user", "company"].includes(viewVal)) {
      viewVal = "user";
      updated = true;
    }
    if (params.get("view") !== viewVal) {
      params.set("view", viewVal);
      updated = true;
    }

    if (updated) {
      history.replace(`/trucks/enquiries?${params.toString()}`);
    }
  }, [location.search, history, backbutton, discovernowbutton, planningbutton]);

  useEffect(() => {
    ReactGA.send("LoRRI Spot - My Enquiries");
    (async function () {
      if (auth?.currentUser?.getIdToken()) {
        document.title = "LoRRI Spot - My Enquiries";
        if (from) {
          document.getElementById("user-journey").click();
        }
        if (backbutton) {
          getBenchmarkData();
        } else if (discovernowbutton) {
          getDatafromdiscovernow();
        } else if (planningbutton) {
          getDatafromPlanning();
        }

      }
    })();
  }, [userDetails]);

  return (
    <div className="w-100">
      <Loader show={show} />
      {!isMobile() ? (
        <>
          {(backbutton || discovernowbutton || planningbutton) && (
            <div className={`${classes["newstyle"]} `}>
              <p className={classes["my-p-head"]}>
                Once you submit, this enquiry will be sent to the listed
                Transporters / Logistics Service Providers(LSPs) along with your
                terms and conditions
              </p>
            </div>
          )}
        </>
      ) : (
        // <div style={{ marginLeft: "2.5%", float: isMobile() ? "right" : "" }}>
        //   <CommonModal
        //     buttonClass={`btn btn-link`}
        //     buttonLabel={
        //       <>
        //         <i
        //           style={{
        //             color: "#393185",
        //             fontSize: "16px",
        //             marginRight: "1%",
        //             cursor: isRestricted ? "not-allowed" : "pointer",
        //             opacity: isRestricted ? 0.6 : 1,
        //           }}
        //           className="fas fa-file-contract"
        //         />
        //       {!isMobile ?  "Update your Terms and Conditions" : "Update Terms and Conditions" } 
        //       </>
        //     }
        //     qualitativeInputs={qualitativeInputs}
        //     dropDownSelect={dropDownSelect}
        //     selectedOrg={selectedOrg}
        //     setSelectedOrg={setSelectedOrg}
        //     setOrgList={setOrgList}
        //     orgList={orgList}
        //     tncData={tncData}
        //     setQualitativeInputs={setQualitativeInputs}
        //     toggleLoader={setshow}
        //     company_id={company_id}
        //     isSuperAdmin={isSuperAdmin}
        //     notnc={notnc}
        //     title={`Your one step away from submitting your enquiry.To help get accurate rates please enter the details below.`}
        //     style={{
        //       border: "none",
        //       cursor: isRestricted ? "not-allowed" : "pointer",
        //       opacity: isRestricted ? 0.6 : 1,
        //     }}
        //     saveButtonText="Submit"
        //     onClose={() => oncloseHandler()}
        //     disabled={isRestricted}
        //     id="tnc"
        //   />
        // </div>
        null
      )}
      {!backbutton && !discovernowbutton && !planningbutton ? (
          <InputFields
            origin={origin}
            setorigin={setorigin}
            inputorigin={inputorigin}
            setinputorigin={setinputorigin}
            destination={destination}
            setdestination={setdestination}
            inputdestination={inputdestination}
            setinputdestination={setinputdestination}
            TruckTypes={TruckTypes}
            onChangeTruckTypes={onChangeTruckTypes}
            selectedTrucks={selectedTrucks}
            capacity={capacity}
            setcapacity={setcapacity}
            tonnage={tonnage}
            settonnage={settonnage}
            truckrequired={truckrequired}
            settruckrequired={settruckrequired}
            date={date}
            setduedate={setduedate}
            addLanetoProcurement={addLanetoProcurement}
            isRestricted={isRestricted}
            checkActionPermission={checkActionPermission}
            selectedIndustry={selectedIndustry}
            setSelectedIndustry={setSelectedIndustry}
            handleIndustryChange={(e) => {
              setSelectedIndustry(e);
            }}
            materialCategories={materialCategories}
            setMaterialCategories={setMaterialCategories}
            renderTermsElement={
              <CommonModal
                buttonClass={`btn btn-link blankborder`}
                buttonLabel={
                  <>
                    <i
                      style={{
                        color: "#393185",
                        fontSize: "14px",
                        marginRight: "4px",
                        cursor:
                          isRestricted || tncNoAccess
                            ? "not-allowed"
                            : "pointer",
                        opacity: isRestricted || tncNoAccess ? 0.6 : 1,
                      }}
                      className="fas fa-file-contract"
                    />
                    <b style={{ fontSize: "12px", color: "#393185" }}>
                      ☷ Update your Terms and Conditions
                    </b>
                  </>
                }
                qualitativeInputs={qualitativeInputs}
                setQualitativeInputs={setQualitativeInputs}
                dropDownSelect={dropDownSelect}
                selectedOrg={selectedOrg}
                setSelectedOrg={setSelectedOrg}
                setOrgList={setOrgList}
                orgList={orgList}
                tncData={tncData}
                toggleLoader={setshow}
                notnc={notnc}
                company_id={company_id}
                isSuperAdmin={isSuperAdmin}
                title="Update Terms & Conditions"
                subtitle="You're one step away from submitting your enquiry. To help get accurate rates please enter the details below."
                titleSize="md"
                style={{
                  border: "none",
                  padding: 0,
                  cursor: isRestricted ? "not-allowed" : "pointer",
                  opacity: isRestricted ? 0.6 : 1,
                }}
                saveButtonText="Submit"
                onClose={() => oncloseHandler()}
                id="tnc"
                disabled={isRestricted}
              />
            }
          />
      ) : (
        <div
          className="row"
          style={{ marginTop: "1%", marginLeft: "1%", width: "100%" }}
        >
          <div className="col-md-8"></div>
          <div
            className="col-md-4"
            style={{ padding: "0", marginTop: "-4.5%" }}
          >
            {!isMobile() && (
              <>
                {!backbutton && !discovernowbutton && !planningbutton ? (
                  <CommonModal
                    buttonClass={`btn btn-link blankborder`}
                    buttonLabel={
                      <>
                        <i
                          style={{
                            color: "#393185",
                            fontSize: "16px",
                            marginRight: "1%",
                            cursor: isRestricted ? "not-allowed" : "pointer",
                            opacity: isRestricted ? 0.6 : 1,
                          }}
                          className="fas fa-file-contract"
                        />
                        <b>Update your Terms and Conditions</b>
                      </>
                    }
                    qualitativeInputs={qualitativeInputs}
                    setQualitativeInputs={setQualitativeInputs}
                    toggleLoader={setshow}
                    notnc={notnc}
                    company_id={company_id}
                    isSuperAdmin={isSuperAdmin}
                    title={`Your one step away from submitting your enquiry.To help get accurate rates please enter the details below.`}
                    closeButtonNeeded={true}
                    style={{
                      border: "none",
                      float: "right",
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    saveButtonText="Submit"
                    onClose={() => oncloseHandler()}
                    id="tnc"
                    disabled={isRestricted}
                  />
                ) : (
                  <CommonModal
                    buttonClass={`btn btn-link`}
                    buttonLabel={
                      <>
                        <i
                          style={{
                            color: "#393185",
                            fontSize: "16px",
                            marginRight: "1%",
                            cursor: isRestricted ? "not-allowed" : "pointer",
                            opacity: isRestricted ? 0.6 : 1,
                          }}
                          className="fas fa-file-contract"
                        />
                        <b>Update your Terms and Conditions</b>
                      </>
                    }
                    qualitativeInputs={qualitativeInputs}
                    notnc={notnc}
                    setQualitativeInputs={setQualitativeInputs}
                    toggleLoader={setshow}
                    company_id={company_id}
                    isSuperAdmin={isSuperAdmin}
                    title={`Your one step away from submitting your enquiry.To help get accurate rates please enter the details below.`}
                    closeButtonNeeded={true}
                    style={{
                      border: "none",
                      float: "right",
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    saveButtonText="Submit"
                    onClose={() => oncloseHandler()}
                    id="tnc"
                    disabled={isRestricted}
                  />
                )}
              </>
            )}
          </div>
        </div>
      )}

      <div>
        {!backbutton && !discovernowbutton && !planningbutton && (
          <EnquiryToolbar
            isdownload={isdownload}
            interval_days={interval_days}
            enquiryBucket={enquiryBucket}
            enquiryLevel={enquiryLevel}
            canAccessReports={canAccessReports}
            auctionAllowed={auctionAllowed}
            isAuction={isAuction}
            allowed_auction={allowed_auction}
            requestapprovallist={requestapprovallist}
            company_name={company_name}
            isRestricted={isRestricted}
            showapprovingloader={showapprovingloader}
            isApprover={isApprover}
            approver_list={approver_list}
            companySettingData={companySettingData}
            autoPushIndent={autoPushIndent}
            setsend_data={setsend_data}
            enquiryTransition={enquiryTransition}
            setmastertransporterlist={setmastertransporterlist}
            planningbutton={planningbutton}
            history={history}
            setRequestapprovallist={setRequestapprovallist}
            setEnquiryBucket={setEnquiryBucket}
            TrackMixPanel={TrackMixPanel}
            visible_enquiry={visible_enquiry}
            closeModal1={closeModal1}
            cancelApprovalPending={cancelApprovalPending}
            backbutton={backbutton}
            discovernowbutton={discovernowbutton}
            setFilter={setFilter}
            apply_Filter={apply_Filter}
            setuserview={setuserview}
            setEnquiryLevel={setEnquiryLevel}
            handleOutsideFilterChange={handleOutsideFilterChange}
            iscompanycheck={iscompanycheck}
          />
        )}
        {filter && (
          <MultiSelectFilterUI
            filterBaseUrl={Urls.spot_filters}
            module="spot"
            action="filterable_fields"
            filterField="filters"
            showViewSelection={iscompanycheck}
            onFilterApply={(payload) => {
              handleFilterApply(payload);
              setFilter(false);
            }}
            defaultSortOptions={DEFAULT_SORT_OPTIONS}
            onReset={() => {
              handleFilterReset();
              setFilter(false);
            }}
            initialPayload={currentFilterPayload}
            isLoading={show}
            onClose={() => setFilter(false)}
            hideItemsPerPage={true}
            defaultLimit={visible_enquiry}
            extraPayload={{
              company_id: company_id,
              email: userDetails?.email,
              bucket: enquiryBucket,
              view: enquiryLevel,
            }}
          />
        )}
      </div>

      <div className={isMobile() ? "" : ""}>
        {/* Active filters pills bar */}
        <ActiveFiltersPills
          isFilterActive={isFilterActive}
          currentFilterPayload={currentFilterPayload}
          handleFilterApply={handleFilterApply}
          handleFilterReset={handleFilterReset}
          setEnquiryBucket={setEnquiryBucket}
          setuserview={setuserview}
          setEnquiryLevel={setEnquiryLevel}
          enquiryLevel={enquiryLevel}
        />

        {!isMobile() ? (
          <AddedLanes
            resdata={resdata}
            getEnquiryApis={getEnquiryApis}
            setNewSpot={setNewSpot}
            newSpot={newSpot}
            enquiryBucket={enquiryBucket}
            backbutton={backbutton}
            discovernowbutton={discovernowbutton}
            planningbutton={planningbutton}
            show={show}
            send_data={send_data}
            requestapprovallist={requestapprovallist}
            setRequestapprovallist={setRequestapprovallist}
            cancelEnquiry={cancelEnquiry}
            apply_Filter={apply_Filter}
            filters_applied={filters_applied}
            visible_enquiry={visible_enquiry}
            skipactive={skipactive}
            useroption={useroption}
            onInputChangeHandler={onInputChangeHandler}
            isPlacement={isPlacement}
            company_id={company_id}
            deleteHandler={deleteHandler}
            transporterlistempty={transporterlistempty}
            getchecked={getchecked}
            addrequest={addrequest}
            isquotationcheck={isquotationcheck}
            getnegotiatedisaable={getnegotiatedisaable}
            enquiryTransition={enquiryTransition}
            profile_view_count={profile_view_count}
            autoPushIndent={autoPushIndent}
            ischat={ischat}
            filtered_details={filtered_details}
            setsend_data={setsend_data}
            TruckTypes={TruckTypes}
            tenurelist={tenurelist}
            mastertransporterlist={mastertransporterlist}

            isApprover={isApprover}
            approvalType={approvalType}
            approver_list={approver_list}
            getEnquiries={getEnquiries}
            userid={userid}
            companyProfileData={companyProfileData}
            companySettingData={companySettingData}
            closeSummaryModal={closeSummaryModal}
            reload_data={reload_data}
            isIndent={isIndent}
            closeIndentModal={closeIndentModal}
            isSuperAdmin={isSuperAdmin}
            profile_view_allowed={profile_view_allowed}
            getStatus={getStatus}
            expiredEnquiries={expiredEnquiries}
            approveEnquiry={approveEnquiry}
            bucket={enquiryBucket}
            isRestricted={isRestricted}
            checkActionPermission={checkActionPermission}
            fetchSpotData={fetchSpotData}
            currentFilterPayload={currentFilterPayload}
          />
        ) : (
          <MobileAddedLanes
            resdata={resdata}
            getEnquiryApis={getEnquiryApis}
            newSpot={newSpot}
            setNewSpot={setNewSpot}
            enquiryBucket={enquiryBucket}
            backbutton={backbutton}
            discovernowbutton={discovernowbutton}
            planningbutton={planningbutton}
            send_data={send_data}
            cancelEnquiry={cancelEnquiry}
            apply_Filter={apply_Filter}
            filters_applied={filters_applied}
            visible_enquiry={visible_enquiry}
            skipactive={skipactive}
            onInputChangeHandler={onInputChangeHandler}
            isPlacement={isPlacement}
            company_id={company_id}
            deleteHandler={deleteHandler}
            transporterlistempty={transporterlistempty}
            getchecked={getchecked}
            addrequest={addrequest}
            isquotationcheck={isquotationcheck}
            getnegotiatedisaable={getnegotiatedisaable}
            enquiryTransition={enquiryTransition}
            profile_view_count={profile_view_count}
            autoPushIndent={autoPushIndent}
            ischat={ischat}
            filtered_details={filtered_details}
            setsend_data={setsend_data}
            TruckTypes={TruckTypes}
            tenurelist={tenurelist}
            mastertransporterlist={mastertransporterlist}

            isApprover={isApprover}
            approvalType={approvalType}
            getEnquiries={getEnquiries}
            userid={userid}
            companyProfileData={companyProfileData}
            closeSummaryModal={closeSummaryModal}
            reload_data={reload_data}
            isIndent={isIndent}
            closeIndentModal={closeIndentModal}
            profile_view_allowed={profile_view_allowed}
            getStatus={getStatus}
            expiredEnquiries={expiredEnquiries}
            approveEnquiry={approveEnquiry}
            bucket={enquiryBucket}
            isRestricted={isRestricted}
            checkActionPermission={checkActionPermission}
            isSuperAdmin={isSuperAdmin}
          />
        )}
      </div>

      <EnquirySubmitFooter
        send_data={send_data}
        validateUser={validateUser}
        backbutton={backbutton}
        discovernowbutton={discovernowbutton}
        planningbutton={planningbutton}
        skipactive={skipactive}
        visible_enquiry={visible_enquiry}
        totalcount={totalcount}
        getOnChange={getOnChange}
        closeButtonModal1={closeButtonModal1}
        submitHandler={submitHandler}
        setsend_data={setsend_data}
        spotNoAccess={spotNoAccess}
        isRestricted={isRestricted}
        showStatusColumn={
          companySettingData?.agent_settings?.spot_negotiation_agent?.allowed === "yes" &&
          companySettingData?.agent_settings?.spot_negotiation_agent?.enabled === "yes" &&
          (companySettingData?.agent_settings?.spot_negotiation_agent?.allowed_users?.some(
            (user) => user?.email?.toLowerCase() === company_mail?.toLowerCase(),
          ) ?? false)
        }
        requestapprovallist={requestapprovallist}
        setRequestapprovallist={setRequestapprovallist}
        company_id={company_id}
        fetchSpotData={fetchSpotData}
        currentFilterPayload={currentFilterPayload}
        defaultRounds={companySettingData?.agent_settings?.spot_negotiation_agent?.default_rounds ?? 3}
      />
    </div>
  );
};
export default NewEnquiry;
